import * as _ from 'lodash';

import { wageModelInfos } from '../objects/WageType';
import { TimeString } from '../misc/TimeString';
import { formatDateDuration } from '../misc/DateCalculator';
import { formatDurationMinutes } from '../misc/textHelper';

angular.module("tromanWeb").filter("ergoPnDate", [function () {

    return function (pn) {
        if (pn == null) return "";
        if (!angular.isString(pn)) return "";

        pn = pn.trim();

        if (pn.length === 6) return pn;
        if (pn.length === 8) return pn;
        if (pn.length === 10) return pn.slice(0, 6);
        if (pn.length === 11) return pn.slice(0, 6);
        if (pn.length === 12) return pn.slice(0, 8);
        if (pn.length === 13) return pn.slice(0, 8);

        return pn.slice(0, 6);
    };
}]);

angular.module("tromanWeb").filter("ergoAddress", [function () {
    return function (addr) {
        var ret = "";
        if (addr == null)
            return ret;
        var a = (addr.Address || "").trim();
        var z = (addr.ZipCode || "").trim();
        var p = (addr.City || "").trim();

        ret += a;
        if (a.length > 0 && (z.length > 0 || p.length > 0)) {
            ret += ", ";
        }
        ret += z;
        if (z.length > 0 && p.length > 0) {
            ret += " ";
        }
        ret += p;

        return ret;
    };
}]);

angular.module("tromanWeb").filter("ergoEnumWageModel", [function () {

    return function (val) {
        var vm = wageModelInfos[val];
        return vm ? vm.name : undefined;
    };
}]);

angular.module("tromanWeb").filter("ergoTimespanDuration", [function () {
    return function (val) {
        if (_.isUndefined(val)) {
            return;
        }

        var ts = TimeString.parse(val);
        if (ts == null) {
            return;
        }

        let h = Math.trunc(ts.duration / 60);
        let m = ts.duration % 60;
        
        if (m > 0) {
            return `${h} timmar ${m} minuter`;
        } else {
            return `${h} timmar`;
        }
    };
}]);

angular.module("tromanWeb").filter("ergoDateDuration", [function () {
    return formatDateDuration;
}]);

angular.module("tromanWeb").filter("ergoDurationMinutes", [function () {
    return function (val) {
        if (_.isFinite(val)) {
            return formatDurationMinutes(val);
        }
        return;
    };
}]);